import { personGroups } from '@/mocks/home';

export default function PersonIndex() {
  return (
    <section id="index" className="w-full px-4 md:px-8 py-12 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-3">
          <span className="text-xs font-label tracking-[0.3em] text-primary-600">04 / 人物索引</span>
          <h3 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">按姓氏查人</h3>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            姓名按拼音首字母归组，点开对应字母即可定位到该组条目与相关事件。
          </p>
          <a
            href="#events"
            className="mt-6 inline-flex items-center gap-2 text-sm font-label text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            或从事件脉络进入
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </a>
        </div>

        <div className="lg:col-span-9 grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-8">
          {personGroups.map((group) => (
            <div key={group.letter} className="border-t-2 border-foreground-950 pt-4">
              <div className="flex items-baseline gap-2">
                <span className="font-heading text-2xl md:text-3xl font-black text-primary-500">{group.letter}</span>
                <span className="text-xs font-label text-foreground-500">{group.names.length} 条</span>
              </div>
              <ul className="mt-3 flex flex-wrap gap-2">
                {group.names.map((name) => (
                  <li key={name}>
                    <a
                      href="#archive"
                      className="inline-block rounded-md border border-background-300 bg-background-50 px-2.5 py-1 text-sm font-label text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
                    >
                      {name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}